<template>
  <div class="hello">
    <!-- 收藏栏 -->
    <div class="welcome">
      <div>您好，欢迎访问易越服务官方网站</div>
      <div class="collect">
        <img class="wel-img" src="../img/collect.png" />
        <span>收藏本站</span>
      </div>
    </div>
    <!-- logo和咨询电话 -->
    <div class="logo">
      <img src="../img/21.png" style="width:18%" alt />
      <div class="tel">
        <img class="tel-img" src="../img/tel.png" />
        <span class="tel-text">免费咨询</span>
        <span class="tel-num">0516-88381896</span>
      </div>
    </div>
    <!-- 顶部导航栏 -->
    <div class="nav">
      <div class="nav-item wire" :class="{red: isActive === 0}" @click="isActive = 0">首页</div>
      <div class="nav-item wire" :class="{red: isActive === 1}" @click="isActive = 1">财税方案</div>
      <div class="nav-item wire" :class="{red: isActive === 2}" @click="isActive = 2">外包服务</div>
      <div class="nav-item" :class="{red: isActive === 3}" @click="isActive = 3">关于我们</div>
    </div>
    <!-- 轮播 -->
    <div style="position: relative;">
      <el-carousel :height="height" indicator-position="none" :autoplay="false">
        <el-carousel-item v-for="item in 3" :key="item">
          <img class="carousel-img" style="width: 100%;" src="../img/lunbo1.png" />
          <p
            style="width: 75%; padding: 0 12.5%; color:white; position: absolute; bottom: 24%; font-size: 20px;"
          >易越系统管理服务，税务、航天信息对接开票系统，注册流程由线下注册变成线上注册，为大批量的客户落地带来了便捷</p>
          <p
            style="width: 54%; padding: 0 23%; color:white; position: absolute; bottom: 11%; font-size: 12px;"
          >
            OUR CURRENT SYSTEM MANAGEMENT SERVICE, TAX AND AEROSPACE INFORMATION DOCKING BILLING SYSTEM, REGISTRATION PROCESS FROM OFFLINE REGISTRATION TO
            ONLINE REGISTRATION, HAS BROUGHT CONVENIENCE FOR LARGE NUMBER OF CUSTOMERS TO LAND
          </p>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 特色 -->
    <div class="feature">
      <div class="feature-box">
        <img style="width:32px; height:36px;" src="../img/youshi.png" />
        <p>优势赋能</p>
      </div>
      <div class="feature-box">
        <img style="width:35px; height:35px;" src="../img/duijie.png" />
        <p>线上对接</p>
      </div>
      <div class="feature-box">
        <img style="width:42px; height:34px;" src="../img/hangye.png" />
        <p>行业领域</p>
      </div>
      <div class="feature-box">
        <img style="width:24px; height:34px;" src="../img/waibao.png" />
        <p>外包服务</p>
      </div>
    </div>
    <!-- 公司简介 -->
    <div class="intro">
      <div class="left-box">
        <h3>公司简介</h3>
        <p class="intro-en">GANGGANGXIANG INTRODUCTION</p>
        <p
          class="intro-content"
        >江苏易越服务外包有限公司隶属江苏省徐州市睢宁县经济开发区，成立于2018年，主要从事招商引资，为中小企业及个人落户提供一站式服务。并提供后续配套服务，让每个入驻企业都享受到睢宁的优惠政策。</p>
        <p
          class="intro-content"
        >江苏易越服务外包有限公司专注工商托管服务，提供注册地址，为大中小规模企业及个人落户睢宁提供便利，所有事项都由我公司办理（即托管）：核税、领票、办理税控盘、报税、开票、年审、涉税处理、财政认定及扶持资金兑现等。</p>
      </div>
      <img class="right-img" src="../img/jianjie.png" />
    </div>
    <!-- 服务对象 -->
    <h3>服务对象</h3>
    <div class="serve-obj">
      <div class="serve-obj-item">
        <div class="serve-obj-item-icon" :class="{red: isActive2 === 0}" @click="isActive2 = 0">
          <img style="width: 45px; height: 40px; margin-top: 5px;" src="../img/geren.png" />
          <p>-</p>
          <p>个人</p>
        </div>
        <div class="serve-obj-item-icon" :class="{red: isActive2 === 1}" @click="isActive2 = 1">
          <img style="width: 43px; height: 43px;" src="../img/dianshang.png" />
          <p>-</p>
          <p>电商</p>
        </div>
        <div class="serve-obj-item-icon" :class="{red: isActive2 === 2}" @click="isActive2 = 2">
          <img style="width: 48px; height: 48px;" src="../img/weishang.png" />
          <p>-</p>
          <p>微商</p>
        </div>
        <div class="serve-obj-item-icon" :class="{red: isActive2 === 3}" @click="isActive2 = 3">
          <img style="width: 45px; height: 45px;" src="../img/gongsi.png" />
          <p>-</p>
          <p>公司</p>
        </div>
      </div>
      <div>
        <p>2019年由于《电商法》及《个税法》的实施，产生了亿级市场的个人，电商，微商及公司，我司现用系统管理服务，税法，航天信息对接开。</p>
      </div>
    </div>
    <!-- 服务项目 -->
    <h3>服务项目</h3>
    <div class="serve-project">
      <el-row style="margin-bottom: 15%;">
        <el-col style="position: relative;" @click.native="isActive3 = 0" :span="8">
          <img src="../img/heshui.png" :class="{borderCol: isActive3 === 0}" />
          <div class="serve-project-item" :class="{contentCol: isActive3 === 0}">
            <h5>核税</h5>
            <p>正确核定企业应纳税种（主 要有增值税、企业所得税、 个人所得税、城市建设税、 教育附加税、印花税）、 税目</p>
          </div>
        </el-col>
        <el-col style="position: relative;" @click.native="isActive3 = 1" :span="8">
          <img src="../img/lingpiao.png" :class="{borderCol: isActive3 === 1}" />
          <div class="serve-project-item" :class="{contentCol: isActive3 === 1}">
            <h5>领票</h5>
            <p>凡缴纳营业税的纳税人在办 理完税务登记的同时到当地 主管地税机关发票销售窗口 领取发票领购簿按照经营项 目购买发票</p>
          </div>
        </el-col>
        <el-col style="position: relative;" @click.native="isActive3 = 2" :span="8">
          <img src="../img/shuikongpan.png" :class="{borderCol: isActive3 === 2}" />
          <div class="serve-project-item" :class="{contentCol: isActive3 === 2}">
            <h5>税控盘</h5>
            <p>税控盘（又称“税控服务器”） 是一种专用的税控装置，按 照国家税务总局的“税控盘 技术规范”进行研制。税控 盘分为单</p>
          </div>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 15%;">
        <el-col style="position: relative;" @click.native="isActive3 = 3" :span="8">
          <img src="../img/baoshui.png" :class="{borderCol: isActive3 === 3}" />
          <div class="serve-project-item" :class="{contentCol: isActive3 === 3}">
            <h5>报税</h5>
            <p>根据增值税防伪税控系统的 设置，月初如果企业不执行 抄税和报税，系统将自动锁 死到时候将影响企业的正常 开票</p>
          </div>
        </el-col>
        <el-col style="position: relative;" @click.native="isActive3 = 4" :span="8">
          <img src="../img/lingpiao.png" :class="{borderCol: isActive3 === 4}" />
          <div class="serve-project-item" :class="{contentCol: isActive3 === 4}">
            <h5>开票</h5>
            <p>不需要再在窗口排队、填写 资料，也不再为“计算税率” 、“现金交款”发愁，直接 至窗口提交订单，直接领票</p>
          </div>
        </el-col>
        <el-col style="position: relative;" @click.native="isActive3 = 5" :span="8">
          <img src="../img/shuikongpan.png" :class="{borderCol: isActive3 === 5}" />
          <div class="serve-project-item" :class="{contentCol: isActive3 === 5}">
            <h5>涉税处理</h5>
            <p>具有良好的科学素养，系 统地、较好地掌握计算机 科学与技术，已为多家知 名企业提供定制服务。</p>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 现已入驻行业 -->
    <h3>现已入驻行业</h3>
    <div class="enter-industry">
      <el-carousel :height="heightBusiness" indicator-position="none" :autoplay="false">
        <el-carousel-item v-for="item in 3" :key="item">
          <el-row class="enter-box" :gutter="30" style="margin-bottom: 20px;">
            <el-col :span="6">
              <div class="enter-industry-card">
                <img src="../img/xinxikeji.png" />
                <div class="enter-industry-content">信息科技</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="enter-industry-card">
                <img src="../img/fuwuwaibao.png" />
                <div class="enter-industry-content">服务外包</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="enter-industry-card">
                <img src="../img/dianzishangwu.png" />
                <div class="enter-industry-content">电子商务</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="enter-industry-card">
                <img src="../img/renliziyuanfuwu.png" />
                <div class="enter-industry-content">人力资源服务</div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col :span="6">
              <div class="enter-industry-card">
                <img src="../img/wuliuyunshu.png" />
                <div class="enter-industry-content">物流运输</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="enter-industry-card">
                <img src="../img/kejifuwu.png" />
                <div class="enter-industry-content">科技服务</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="enter-industry-card">
                <img src="../img/jianzhu.png" />
                <div class="enter-industry-content">建筑</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="enter-industry-card">
                <img src="../img/lvyoulei.png" />
                <div class="enter-industry-content">旅游类</div>
              </div>
            </el-col>
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 合作伙伴 -->
    <h3 style="margin-top:50px;">合作伙伴</h3>
    <div class="partner">
      <el-row style="margin-bottom: 10px">
        <el-col :span="12">1、杭州工猫科技有限公司</el-col>
        <el-col :span="12">2、杭州乐客文化传媒有限公司（品牌：乐客独角兽）</el-col>
      </el-row>
      <el-row style="margin-bottom: 10px">
        <el-col :span="12">3、宁波美味发现信息科技有限公司</el-col>
        <!-- <el-col :span="12">3、宁波美味发现信息科技有限公司</el-col> -->
      </el-row>
      <!-- <el-row style="margin-bottom: 10px">
        <el-col :span="12">5、深圳中兴飞贷金融科技有限公司</el-col>
        <el-col :span="12">5、深圳中兴飞贷金融科技有限公司</el-col>
      </el-row>
      <el-row>
        <el-col :span="12">5、深圳中兴飞贷金融科技有限公司</el-col>
      </el-row>-->
    </div>
    <!-- 底部 -->
    <div class="footer">
      <div class="footer-top">
        <div class="footer-logo">
          <img src="../img/21.png" style="width:100%" alt />
        </div>
        <div>
          <i class="el-icon-phone-outline"></i>
          <span>0516-88381896</span>
        </div>
        <div>
          <i class="el-icon-location-outline"></i>
          <span>江苏省睢宁县经济开发区小布网大楼868室</span>
        </div>
      </div>
      <p>技术支持某策略© 版权所有 588kuNetwork All Rights Reserved 苏ICP备19067033号</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
    return {
      isActive: 0,
      isActive2: 0,
      isActive3: 0,
      height: '390px',
      heightBusiness: '400px'
    }
  },
  mounted() {
    let imgH = document.getElementsByClassName('carousel-img')[0]
    let boxH = document.getElementsByClassName('enter-box')[0]
    // 拿到轮播图片高度
    this.$nextTick(() => {
      setTimeout(() => {
        this.height = imgH.clientHeight + 'px'
        this.heightBusiness = boxH.clientHeight * 2 + 40 + 'px'
      }, 1000)
    })
    // 监听窗口尺寸改变
    window.onresize = () => {
      return (() => {
        this.$nextTick(() => {
          setTimeout(() => {
            this.height = imgH.clientHeight + 'px'
            this.heightBusiness = boxH.clientHeight * 2 + 40 + 'px'
          }, 1000)
        })
      })()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.welcome {
  width: 60%;
  height: 30px;
  padding: 0 20%;
  background: rgba(240, 240, 240, 1);
  color: rgba(100, 100, 100, 1);
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .collect {
    display: flex;
    align-items: center;

    .wel-img {
      width: 15px;
      height: 15px;
    }
  }
}

.logo {
  width: 58%;
  height: 110px;
  padding: 0 21%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .icon {
    width: 133px;
    height: 40px;
    background: rgba(230, 0, 18, 1);
    border-radius: 4px;
    font-size: 24px;
    line-height: 40px;
    color: rgba(255, 255, 255, 1);
  }

  .tel {
    display: flex;
    align-items: center;

    .tel-img {
      width: 26px;
      height: 26px;
    }

    .tel-text {
      font-size: 16px;
      color: rgba(150, 150, 150, 1);
      margin: 0 5px;
    }

    .tel-num {
      color: rgba(255, 0, 0, 1);
      font-size: 27px;
    }
  }
}

.nav {
  width: 50%;
  padding-left: 50%;
  height: 60px;
  background: rgba(50, 50, 50, 1);

  .nav-item {
    width: 149px;
    height: 60px;
    color: white;
    line-height: 60px;
    font-size: 14px;
    text-align: center;
    display: inline-block;
    cursor: pointer;
  }

  .wire {
    border-right: 1px solid #fff;
  }

  .red {
    background: rgba(245, 10, 10, 1);
  }
}

.feature {
  width: 50%;
  height: 170px;
  padding: 0 25%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(230, 230, 230, 1);

  .feature-box {
    width: 100px;
    height: 100px;
    background: rgba(246, 246, 246, 1);
    border-radius: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    p {
      margin: 0;
      margin-top: 12px;
      font-size: 14px;
    }
  }
}

.intro {
  width: 62%;
  padding: 0 19%;
  text-align: left;

  .left-box {
    width: 40%;
    padding: 39px 0 8%;
    margin-right: 20px;
    display: inline-block;

    .intro-en {
      color: rgba(230, 0, 18, 1);
      font-size: 14px;
    }

    .intro-content {
      font-size: 16px;
      color: rgba(102, 102, 102, 1);
    }
  }

  .right-img {
    width: 56%;
    height: 100%;
  }
}

.serve-obj {
  width: 62%;
  padding: 5% 19% 0;
  background: url('../img/fuwuduixiang.png') no-repeat left top / 100% 100%;
  color: #fff;

  .serve-obj-item {
    display: flex;
    justify-content: space-between;

    .serve-obj-item-icon {
      padding: 4% 8.5%;
      border: 3px solid #fff;

      p {
        margin: 0;
      }
    }

    .red {
      background-color: rgba(223, 32, 36, 1);
      border-color: rgba(223, 32, 36, 1);
    }
  }
}

.serve-project {
  width: 62.5%;
  padding: 0 18.75%;
  text-align: left;

  img {
    width: 52%;
    border: 5px solid #575454;
  }

  .borderCol {
    border-color: #dd0010;
  }

  .contentCol {
    background-color: #dd0010 !important;
    color: #fff;
  }

  .serve-project-item {
    width: 35%;
    padding: 8%;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 21px 0px rgba(165, 165, 165, 0.2);
    position: absolute;
    top: 19%;
    left: 41%;

    h5 {
      margin-top: 0;
    }

    p {
      font-size: 12px;
      margin-bottom: 0;
    }
  }
}

.enter-industry {
  width: 62.5%;
  padding: 0 18.75%;

  .enter-industry-card {
    box-shadow: 0px 5px 15px 0px rgba(20, 7, 0, 0.1);
  }

  img {
    width: 100%;
  }

  .enter-industry-content {
    width: 100%;
    padding: 20% 0;
    display: inline-block;
  }
}

.partner {
  width: calc(62.5% - 72px);
  padding: 36px;
  margin: 0 18.75%;
  border: 1px solid rgba(50, 50, 50, 1);
  font-weight: 600;
  text-align: left;
}

.footer {
  width: 62.5%;
  height: 200px;
  padding: 0 18.75%;
  margin-top: 136px;
  background: rgba(46, 48, 51, 1);
  color: #fff;
  text-align: left;

  .footer-top {
    display: flex;
    justify-content: space-around;
    padding: 40px 0 58px;
    border-bottom: 1px solid #414245;

    div {
      // margin-right: 108px;
      display: inline-block;
    }

    .footer-logo {
      width: 125px;
      height: 45px;
      color: rgba(56, 56, 56, 1);
      font-size: 20px;
      line-height: 45px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      text-align: center;
      padding: 10px;
    }
  }

  p {
    color: #7a7b7c;
    text-align: center;
    font-size: 12px;
    margin-bottom: 0;
  }
}

h3 {
  margin-top: 0;
}
</style>
